import { Controller } from "@hotwired/stimulus"
import { hideElement, showElement } from "utils/toggle_element_visibility"

export default class extends Controller {
  static values = {
    timezone: String
  }

  connect() {
    this.adjustVisibility()
  }

  adjustVisibility() {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (userTimezone === this.timezoneValue) {
      hideElement(this.element)
    } else {
      showElement(this.element)
    }
  }
}
